module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 3.80688","quantity":0.03807},{"color":"#9dc4b5","label":" 3.80688- 7.0765","quantity":0.07076},{"color":"#e6efc3","label":" 7.0765- 8.35844","quantity":0.08358},{"color":"#ffe89e","label":" 8.35844- 9.99418","quantity":0.09994},{"color":"#f5af7f","label":" 9.99418- 12.10628","quantity":0.12106},{"color":"#ed6d32","label":" 12.10628- 24.65454","quantity":0.24655}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_100_return_10.json
// module id = xyhi
// module chunks = 171